import type { ApiKey } from '@/shared/api';
import { formatDateTime, formatRelativeTime } from '@/shared/lib/date';
import { pluralRu } from '@/shared/lib/plural';

export type ApiKeyState = 'active' | 'revoked' | 'expired';

export function apiKeyState(key: ApiKey, now = Date.now()): ApiKeyState {
  if (key.revokedAt) return 'revoked';
  return new Date(key.expiresAt).getTime() <= now ? 'expired' : 'active';
}

export const API_KEY_STATE_LABEL: Record<Exclude<ApiKeyState, 'active'>, string> = {
  revoked: 'отозван',
  expired: 'истёк',
};

export function apiKeyMeta(key: ApiKey): string {
  const parts = [
    `${key.prefix}…`,
    `${key.scopes.length} ${pluralRu(key.scopes.length, 'право', 'права', 'прав')}`,
    key.canWrite ? 'с изменениями' : 'только чтение',
  ];
  const state = apiKeyState(key);
  if (state === 'active') parts.push(`до ${formatDateTime(key.expiresAt)}`);
  parts.push(key.lastUsedAt ? `использован ${formatRelativeTime(key.lastUsedAt)}` : 'ещё не использован');
  return parts.join(' · ');
}
